import { render, staticRenderFns } from "./invigilator.vue?vue&type=template&id=43510681&scoped=true"
import script from "./invigilator.vue?vue&type=script&lang=js"
export * from "./invigilator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43510681",
  null
  
)

export default component.exports